import React, { useRef, Fragment, useState, useEffect } from 'react';
import { t } from 'i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Col, Container, Modal, Row } from 'react-bootstrap';
import { axiosInstance } from '../../../../api/axios';
import APIEndpoints from '../../../api/APIEndpoints';
import GenericButton from 'src/Components/GenericButton/GenericButton';
import backBtn from '../../../img/pricecompare/back-btn.svg';
import './ResultPage.scss';
import FinalResultTile from '../components/FinalResultTile/FinalResultTile';
import { useSelector } from 'react-redux';
import CompareResultsCard from '../skeleton/CompareResultsCard';
import LongTimeError from '../../common/long-time-error/LongTimeError';
import {
  apiDataGenerationForCompare,
  formatDoctorName,
  getDataByClaimID,
} from 'src/Member/utils/common';
import DataNotFound from '../../common/dataNotFound/DataNotFound';
import { ConfigurationSVG } from 'src/Admin/img/GlobalSVG';

const ResultPage = () => {
  const { id } = useParams();
  console.log('id ResultPage', id);
  let { selectedCheckedRowData } = useSelector((state) => state.priceCompare);
  const {
    searchParamsForUI,
    searchProviderParams,
    providerType,
    selectedCheckedItems,
  } = useSelector((state) => state.priceCompare);
  const allFilters = useSelector(
    ({ priceCompare }) => priceCompare.searchProviderParams.filters,
  );
  const { Provider } = allFilters;
  const {
    Display_Network_For_PriceComparison_Member,
    Value_Network_For_PriceComparison_Member,
  } = useSelector((state) => state?.app?.appConfigs?.Network_Setting);
  const { loggedInUserOID, loggedInMemberType } = useSelector(
    (state) => state.memberSummary,
  );

  const { PriceComparison_Setting } =
    useSelector((state) => state.app?.appConfigs) || {};

  const disclaimerText = PriceComparison_Setting.Disclaimer;

  const [isOpenDisclaimerPopup, setisOpenDisclaimerPopup] = useState(false);

  const handleClose = () => {
    setisOpenDisclaimerPopup(false);
  };

  const CoveredCostComparePriceArray = [];
  const [isLoading, SetIsLoading] = useState(false);
  const [paramsData, setParamsData] = useState(searchParamsForUI);
  const [compareData, setCompareData] = useState([]);
  const [requestID, setRequestID] = useState('');
  const [recentSearchBack, setRecentSearchBack] = useState(false);
  const noResultsFound = false;
  const [noResult, setNoResult] = useState(false);
  const searchTerm = `Request ID ${requestID} / ${paramsData?.typesOfSpecialtyData?.label}`;
  const navigate = useNavigate();
  const location = useLocation();
  const pageInfo = useRef(null);
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  });

  useEffect(() => {
    setTimeout(() => {
      if (pageInfo && pageInfo.current) {
        pageInfo.current.focus();
      }
    }, 10);
  }, []);

  const getFormattedApiData = () => {
    const DATA = [];
    let billedAmountVal;

    if (searchParamsForUI?.billedamount === '') {
      billedAmountVal = Number(searchParamsForUI?.billedamount);
    } else {
      billedAmountVal = searchParamsForUI?.billedamount;
    }

    selectedCheckedRowData.map((item) => {
      const obj = {
        MemberType: loggedInMemberType,
        SelEmployeeMemberOID: loggedInUserOID,
        Serviceprovider: item?.NationalProviderId,
        BilledAmt: billedAmountVal,
      };
      console.log('debug_item', item);
      if (item?.CignaProviderFlag === 'R') {
        obj.ProviderNPID = item?.NationalProviderId;
        obj.Providertaxid = item?.TaxID || item?.TaxId;
        obj.ProvAddress1 = item?.Address?.AddressLine1 || item?.Address1;
        obj.ProvAddress2 = item?.Address?.AddressLine2 || item?.Address2;
        obj.ProvAddress3 = item?.Address?.AddressLine3 || item?.Address3;
        obj.ProvState = item?.Address?.State || item?.StateProv;
        obj.ProvCity = item?.Address?.City || item?.City;
        obj.ProvCounty =
          item?.Address?.County || item?.County === null
            ? undefined
            : item?.County;
        obj.ProvZipCode = item?.Address?.PostalCode || item?.PostalCode;
        delete obj.Serviceprovider;
      }
      if (searchParamsForUI?.helthProcedureData?.codeName) {
        switch (searchParamsForUI?.helthProcedureData?.codeName) {
          case 'CPT4 Codes':
            obj.CptHCPCSCode =
              searchParamsForUI?.helthProcedureData?.value?.toString();
            obj.CodeOption = 'CPT';
            obj.CodeDescription = 'CPTCode';
            break;
          case 'Revenue Codes':
            obj.RevenueCode =
              searchParamsForUI?.helthProcedureData?.value?.toString();
            obj.CodeOption = 'Revenue';
            obj.CodeDescription = 'RevenueCode';
            break;
          case 'CDT5 Dental Codes':
            obj.CDT = searchParamsForUI?.helthProcedureData?.value?.toString();
            obj.CodeOption = 'CDT';
            obj.CodeDescription = 'CDTCode';
            break;
          case 'DRG Codes':
            obj.DRGCode =
              searchParamsForUI?.helthProcedureData?.value?.toString();
            obj.CodeOption = 'DRGCode';
            obj.CodeDescription = 'DRGCode';
            break;
          case 'HCPCS Codes':
            obj.CptHCPCSCode =
              searchParamsForUI?.helthProcedureData?.value?.toString();
            obj.CodeOption = 'CPT';
            obj.CodeDescription = 'CptHCPCSCode';
            break;
          case 'CPT':
            obj.CptHCPCSCode =
              searchParamsForUI?.helthProcedureData?.value?.toString();
            obj.CodeOption = 'CPT';
            obj.CodeDescription = 'CptHCPCSCode';
            break;
          default:
            obj.CptHCPCSCode =
              searchParamsForUI?.helthProcedureData?.value?.toString();
            obj.CodeOption = '';
            obj.CodeDescription = '';
            break;
        }
      }
      if (searchProviderParams?.selectedNetwork?.NetworkCode) {
        obj.NetworkID = searchProviderParams?.selectedNetwork?.NetworkCode;
      }
      DATA.push(obj);
      return;
    });
    return DATA;
  };

  const API_PAYLOAD = {
    pricecompareClaim: {
      searchParams: {
        providerType: providerType,
        procedureForData: searchParamsForUI?.procedureForData,
        helthProcedureData: searchParamsForUI?.helthProcedureData,
        locationData: searchParamsForUI?.locationData,
        providerByData: searchParamsForUI?.filters?.providerByData
          ? searchParamsForUI?.filters?.providerByData
          : searchParamsForUI?.providerByData,
        networksData: searchParamsForUI?.networksData,
        typesOfSpecialtyData: searchParamsForUI?.typesOfSpecialtyData,
        maximumradius: searchProviderParams?.filters?.maximumradius,
        Gender: searchProviderParams?.filters?.Gender,
        AcceptingNewPatients: searchProviderParams?.AcceptingNewPatients,
        spokenlanguages: searchProviderParams?.filters?.spokenlanguages,
        specialities: searchProviderParams?.filters?.specialities,
        BilledAmt: searchParamsForUI?.billedamount,
      },
      comparison: {
        selectedCheckedItems: selectedCheckedItems,
        selectedCheckedRowData: selectedCheckedRowData,
      },
      apiData:
        searchProviderParams?.selectedNetwork?.ProviderDirectory === 'R'
          ? getFormattedApiData()
          : apiDataGenerationForCompare({
              loggedInUserOID,
              loggedInMemberType,
              selectedCheckedItems,
              searchParamsForUI,
              searchProviderParams,
            }),
    },
  };

  const getPostRequestData = async () => {
    const response = await axiosInstance.post(
      APIEndpoints.getComparedRequestId() + '/storeasrecent/true',
      API_PAYLOAD,
    );
    const postAddUserDataResp = response.data;
    const DATA = [];
    if (postAddUserDataResp?.Response?.PriceCompareClaimDTO?.length === 0) {
      setNoResult(true);
    }
    postAddUserDataResp.Response.PriceCompareClaimDTO.map((apiItem) => {
      console.log('apiItem', apiItem);
      //We will/should filter based upon Provider ID , oncewe will start getting ID in API response
      const currentItem = selectedCheckedRowData?.filter((item) => {
        console.log('debug_mine', item, apiItem);
        if (item?.CignaProviderFlag === 'R') {
          if (Provider === 'doctor') {
            return (
              item?.NationalProviderId === apiItem?.ProviderNPI &&
              item?.TaxID === apiItem?.FacilityTAX
            );
          }
          if (Provider === 'facility') {
            return (
              item?.NationalProviderId === apiItem?.ProviderNPI &&
              item?.TaxId === apiItem?.FacilityTAX
            );
          }
        } else {
          return Number(item?.ConnectorId) === Number(apiItem?.ServiceProvider);
        }
      })[0];

      console.log('currentItem', currentItem);
      setRequestID(apiItem?.RequestId);

      if (Provider === 'doctor') {
        DATA.push({
          Gender: currentItem?.Gender,
          ClaimNumber: apiItem?.ClaimNumber,
          Disclaimer: apiItem?.Disclaimer,
          RequestId: apiItem?.RequestId,
          ProviderName: formatDoctorName(
            currentItem?.DoctorTitle,
            currentItem?.LastName,
            currentItem?.FirstName,
            currentItem?.MiddleName,
            currentItem?.Suffix,
          ),
          YearInPractice: currentItem?.Experiance,
          Provider: 'doctor',
          Specialty: currentItem?.Specialties,
          Distance: currentItem?.Distance,
          InNetwork: currentItem?.InNetwork, //InNetwork/OutOfNetwork
          ClaimData: {},
          Address: currentItem?.Address,
          SpokenLanguages: currentItem?.SpokenLanguages,
          DoctorNetworks: currentItem?.DoctorNetworks,
          PhysicianID: currentItem?.PhysicianID,
          Rate: currentItem?.Rate,
        });
      }
      if (Provider === 'facility') {
        DATA.push({
          ClaimNumber: apiItem?.ClaimNumber,
          Disclaimer: apiItem?.Disclaimer,
          RequestId: apiItem?.RequestId,
          ProviderName: currentItem?.FacilityName,
          Specialty: currentItem?.FacilitySpeciality,
          Distance: currentItem?.Miles_Distance,
          InNetwork: currentItem?.InNetwork, //InNetwork/OutOfNetwork
          ClaimData: {},
          Provider: 'facility',
          Address: {
            AddressLine1: currentItem?.Address1,
            AddressLine2: currentItem?.Address2,
            AddressLine3: currentItem?.Address3,
            City: currentItem?.City,
            County: currentItem?.County,
            State: currentItem?.StateProv,
            PostalCode: currentItem?.PostalCode,
            Coordinateds: currentItem?.Coordinateds,
          },
          DoctorNetworks: currentItem?.DoctorNetworks,
          PhysicianID: currentItem?.FacilityID,
          Rate: currentItem?.Rate,
        });
      }
      return;
    });

    if (DATA && DATA.length > 0) {
      const RequestId =
        response.data.Response.PriceCompareClaimDTO[0].RequestId;
      const promises = [
        (async () => {
          const DataItem = await axiosInstance.get(
            APIEndpoints.getCompareClaimDetails() +
              DATA.map((providerItem) => providerItem?.ClaimNumber)?.join(',') +
              (RequestId ? `/requestid/${RequestId}` : ''),
          );
          return DataItem;
        })(),
      ];

      try {
        const results = await Promise.all(
          promises.map((p) => p.catch((e) => e)),
        );
        const validResults = results.filter(
          (result) => !(result instanceof Error),
        );
        console.log('validResults', validResults);
        const listClaimsData = getDataByClaimID(validResults);
        console.log('listClaimsData', listClaimsData);
        DATA.map((provider) => {
          console.log('DATA provider 1234---', provider);
          if (
            provider &&
            provider.ClaimNumber &&
            listClaimsData &&
            listClaimsData.length > 0
          ) {
            const arrClaims = listClaimsData.filter((f) =>
              f?.claimId?.includes(provider.ClaimNumber),
            );
            provider.ClaimData = arrClaims[0]?.data?.filter(
              (item) => item?.ClaimNumber === provider.ClaimNumber,
            )[0];
          }
          return;
        });
        console.log('DATA++++', DATA);
      } catch (error) {
        console.log('Claims API fails');
      }
    }

    setCompareData([...DATA]);
    SetIsLoading(false);
  };
  const loadRequest = async () => {
    const URL = APIEndpoints.getPriceCompareDetailsById() + id;
    const response = await axiosInstance.get(URL);
    const postAddUserDataResp = response?.data;

    const requestData = postAddUserDataResp.Response.PriceCompareDTO;
    const DATA = requestData?.responseObj?.PriceCompareResponse;
    setParamsData(requestData?.requestObj?.searchParams);
    selectedCheckedRowData =
      requestData?.requestObj?.comparison?.selectedCheckedRowData;
    if (DATA && DATA.length > 0) {
      const RequestId =
        requestData?.responseObj?.PriceCompareResponse[0]?.RequestId;
      const promises = [
        (async () => {
          const DataItem = await axiosInstance.get(
            APIEndpoints.getCompareClaimDetails() +
              DATA.map((providerItem) => providerItem?.ClaimNumber)?.join(',') +
              (RequestId ? `/requestid/${RequestId}` : ''),
          );
          return DataItem;
        })(),
      ];

      try {
        const results = await Promise.all(
          promises.map((p) => p.catch((e) => e)),
        );
        const validResults = results.filter(
          (result) => !(result instanceof Error),
        );
        const listClaimsData = getDataByClaimID(validResults);
        if (requestData?.requestObj?.searchParams?.providerType === 'doctor') {
          DATA.map((provider) => {
            if (
              provider &&
              provider.ClaimNumber &&
              listClaimsData &&
              listClaimsData.length > 0
            ) {
              const arrClaims = listClaimsData.filter((f) =>
                f.claimId.includes(provider.ClaimNumber),
              );
              provider.ClaimData = arrClaims[0]?.data?.filter(
                (item) => item?.ClaimNumber === provider.ClaimNumber,
              )[0];

              const currentItem = selectedCheckedRowData?.filter((item) => {
                if (item?.CignaProviderFlag === 'R') {
                  return (
                    item?.NationalProviderId === provider?.ProviderNPI &&
                    item?.TaxID === provider?.FacilityTAX
                  );
                } else {
                  return (
                    Number(item?.ConnectorId) ===
                    Number(provider?.ServiceProvider)
                  );
                }
              })[0];
              provider.Gender = currentItem?.Gender;
              setRequestID(provider?.RequestId);
              provider.ProviderName = formatDoctorName(
                currentItem?.DoctorTitle,
                currentItem?.LastName,
                currentItem?.FirstName,
                currentItem?.MiddleName,
                currentItem?.Suffix,
              );
              provider.YearInPractice = currentItem?.Experiance;
              provider.Provider = 'doctor';
              provider.Specialty = currentItem?.Specialties;
              provider.Distance = currentItem?.Distance;
              provider.InNetwork = currentItem?.InNetwork;
              provider.Address = currentItem?.Address;
              provider.SpokenLanguages = currentItem?.SpokenLanguages;
              provider.DoctorNetworks = currentItem?.DoctorNetworks;
              provider.PhysicianID = currentItem?.PhysicianID;
              provider.Rate = currentItem?.Rate;
            }
            return;
          });
        }
        if (
          requestData?.requestObj?.searchParams?.providerType === 'facility'
        ) {
          DATA.map((provider) => {
            if (
              provider &&
              provider.ClaimNumber &&
              listClaimsData &&
              listClaimsData.length > 0
            ) {
              const arrClaims = listClaimsData.filter((f) =>
                f.claimId?.includes(provider.ClaimNumber),
              );
              provider.ClaimData = arrClaims[0]?.data?.filter(
                (item) => item?.ClaimNumber === provider.ClaimNumber,
              )[0];

              const currentItem = selectedCheckedRowData?.filter((item) => {
                if (item?.CignaProviderFlag === 'R') {
                  return (
                    item?.NationalProviderId === provider?.ProviderNPI &&
                    item?.TaxId === provider?.FacilityTAX
                  );
                } else {
                  return (
                    Number(item?.ConnectorId) ===
                    Number(provider?.ServiceProvider)
                  );
                }
              })[0];
              setRequestID(provider?.RequestId);
              provider.ProviderName = currentItem?.FacilityName;
              //provider.YearInPractice = currentItem?.Experiance;
              provider.Specialty = currentItem?.FacilitySpeciality;
              provider.Provider = 'facility';
              provider.Distance = currentItem?.Miles_Distance;
              provider.InNetwork = currentItem?.InNetwork;
              (provider.Address = {
                AddressLine1: currentItem?.Address1,
                AddressLine2: currentItem?.Address2,
                AddressLine3: currentItem?.Address3,
                City: currentItem?.City,
                County: currentItem?.County,
                State: currentItem?.StateProv,
                PostalCode: currentItem?.PostalCode,
                Coordinateds: currentItem?.Coordinateds,
              }),
                //provider.SpokenLanguages = currentItem?.SpokenLanguages;
                (provider.DoctorNetworks = currentItem?.DoctorNetworks);
              provider.PhysicianID = currentItem?.FacilityID;
              provider.Rate = currentItem?.Rate;
            }
            return;
          });
        }
        console.log(DATA);
        setRecentSearchBack(true);
      } catch (error) {
        console.log('Claims API fails', error);
      }
      setCompareData([...DATA]);
      SetIsLoading(false);
    } else {
      setNoResult(true);
    }
  };
  useEffect(() => {
    if (location.state?.from === 'search') {
      SetIsLoading(true);
      (async () => {
        try {
          await getPostRequestData();
        } catch (error) {
          console.log(error);
          SetIsLoading(false);
        }
      })();
    }
    if (id) {
      SetIsLoading(true);
      (async () => {
        try {
          await loadRequest();
        } catch (error) {
          console.log(error);
          SetIsLoading(false);
        }
      })();
    }
  }, [location]);

  const linkHandler = () => {
    navigate('/member/price-compare');
  };
  const goBack = () => {
    recentSearchBack
      ? location?.state?.viewAllLinkVisible
        ? navigate('/member/price-compare')
        : navigate('/member/price-compare/all-service-request')
      : navigate('/member/price-compare/search-results', {
          state: {
            procedureForData: paramsData?.procedureForData,
            helthProcedureData: paramsData?.helthProcedureData,
            locationData: paramsData?.locationData,
            providerByData: paramsData?.providerByData,
            typesOfSpecialtyData: paramsData?.typesOfSpecialtyData,
            billedamount:
              paramsData?.BilledAmt || searchParamsForUI?.billedamount,
            CoveredCostComparePriceArray: CoveredCostComparePriceArray,
          },
        });
  };
  console.log('compareData', compareData);
  return (
    <div className="price-compare-result-page">
      <Container>
        <span
          className="sr-only"
          role="heading"
          aria-level={1}
          tabIndex={-1}
          ref={pageInfo}
        >
          {t('member.price_comparison.accessibility_page_info')}
        </span>
        <div className="header-container">
          <div className="d-flex align-items-center">
            <span>
              <img
                className="back-btn-to-serach-page"
                src={backBtn}
                role="button"
                alt="Click to Go Back"
                onClick={() => goBack()}
              />
            </span>
            <h1 className="content-header m-0" aria-hidden={true}>
              {t('member.price_comparison.heading_text_compare')}{' '}
              <span className="content-header-bold">
                {t('member.price_comparison.heading_text_price')}
              </span>
            </h1>
          </div>
          <div className="modify-btn-container my-auto">
            <GenericButton
              className="modify-filter-btn"
              variant="secondary"
              onClick={() => {
                navigate('/member/price-compare');
              }}
              ariaLabel={t(
                'member.price_comparison.another_search_btn_ariaLabel',
              )}
            >
              {t('member.price_comparison.another_search_btn_label')}
            </GenericButton>
          </div>
        </div>
        <div className="id-disclaimer-wraper">
          {requestID && (
            <div className="request-id-container">
              {t('member.price_comparison.request_id_label')} {requestID}
            </div>
          )}
          <div className="disclaimer-container">
            {t('member.price_comparison.disclaimer')}
          </div>
        </div>
        <div className="read-only-data-container">
          <div>
            <div>
              <div
                className="main-wrapper1 d-flex justify-content-between mt-3"
                role="region"
                aria-label={t(
                  'member.price_comparison.procedure_container.accessibility_container_info',
                )}
              >
                <div className="top">
                  <div className="top-container">
                    <div>
                      <div className="service-provider">
                        <div className="text-container">
                          {t(
                            'member.price_comparison.procedure_container.container_text',
                          )}
                        </div>
                        <div className="flex-container">
                          <div className="search-result-data">
                            <span className="search-result-data-heading">
                              {t(
                                'member.price_comparison.procedure_container.service_for_label',
                              )}
                            </span>
                            {paramsData?.procedureForData?.label}
                            <span className="pipe">&nbsp;|&nbsp;</span>
                          </div>

                          <div className="search-result-data ">
                            <span className="search-result-data-heading">
                              {t(
                                'member.price_comparison.procedure_container.health_procedure_label',
                              )}
                            </span>
                            {paramsData?.helthProcedureData?.label}
                          </div>
                          {paramsData?.BilledAmt &&
                          paramsData?.BilledAmt !== '0.00' ? (
                            <span className="pipe">&nbsp;|&nbsp;</span>
                          ) : (
                            searchParamsForUI?.billedamount &&
                            searchParamsForUI?.billedamount !== '0.00' && (
                              <span className="pipe">&nbsp;|&nbsp;</span>
                            )
                          )}
                          {paramsData?.BilledAmt &&
                          paramsData?.BilledAmt !== '0.00' ? (
                            <div className="search-result-data">
                              <span className="search-result-data-heading mt-4">
                                {t(
                                  'member.price_comparison.procedure_container.billed_amount',
                                )}{' '}
                              </span>
                              {paramsData?.BilledAmt}
                            </div>
                          ) : (
                            searchParamsForUI?.billedamount &&
                            searchParamsForUI?.billedamount !== '0.00' && (
                              <div className="search-result-data">
                                <span className="search-result-data-heading mt-4">
                                  {t(
                                    'member.price_comparison.procedure_container.billed_amount',
                                  )}{' '}
                                </span>
                                {`$${searchParamsForUI?.billedamount}`}
                              </div>
                            )
                          )}
                        </div>
                      </div>
                      <div className="service-provider">
                        <div className="text-container">
                          {t(
                            'member.price_comparison.provider_container.container_text',
                          )}
                        </div>
                        <div className="flex-container">
                          <div className="search-result-data">
                            <span className="search-result-data-heading">
                              {t(
                                'member.price_comparison.provider_container.location_label',
                              )}
                            </span>
                            {paramsData?.locationData}
                          </div>

                          <div className="search-result-data">
                            <span className="pipe">&nbsp;|&nbsp;</span>
                            <span className="search-result-data-heading">
                              {paramsData?.networksData?.isTier
                                ? t(
                                    'member.price_comparison.provider_container.networks_dropdown_labelTier',
                                  ) + ' : '
                                : Display_Network_For_PriceComparison_Member &&
                                  Value_Network_For_PriceComparison_Member ===
                                    'tier'
                                ? t(
                                    'member.price_comparison.provider_container.networks_dropdown_labelTier',
                                  ) + ' : '
                                : t(
                                    'member.price_comparison.provider_container.networks_dropdown_label',
                                  ) + ' : '}
                            </span>
                            {paramsData?.networksData?.label ||
                              'All Plan Networks'}
                          </div>

                          {paramsData?.typesOfSpecialtyData?.label && (
                            <div className="search-result-data">
                              <span className="pipe">&nbsp;|&nbsp;</span>
                              <span className="search-result-data-heading">
                                {paramsData?.providerByData === 'doctor-name'
                                  ? t(
                                      'member.price_comparison.provider_container.by_doctor_name',
                                    )
                                  : paramsData?.providerByData === 'doctor-type'
                                  ? t(
                                      'member.price_comparison.provider_container.by_doctor_specialty',
                                    )
                                  : paramsData?.providerByData ===
                                    'facility-type'
                                  ? ' Facility Type'
                                  : ' Facility Name or Tax ID'}{' '}
                                :{' '}
                              </span>
                              {paramsData?.typesOfSpecialtyData?.label}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="warning-parent mt-3">
              <div className="disclaimer-svg pt-1">
                <ConfigurationSVG.WarningSVG />
              </div>
              <div className="warning-content">
                <span className="content-bold">Disclaimer: {''}</span>
                <span className="disclaimer-text search-page-disclaimer-text">
                  {disclaimerText}
                </span>
                {disclaimerText?.length > 80 && (
                  <span className="button-position" aria-hidden={true}>
                    <GenericButton
                      variant="link"
                      className="viewmore-btn"
                      onClick={() => {
                        setisOpenDisclaimerPopup(!isOpenDisclaimerPopup);
                      }}
                    >
                      View More
                    </GenericButton>
                  </span>
                )}
              </div>
            </div>
            {isOpenDisclaimerPopup && (
              <div>
                <Modal
                  show={isOpenDisclaimerPopup}
                  onHide={handleClose}
                  centered
                  className={`Right-Model member generic-model`}
                >
                  <Modal.Header closeButton className="plandocument-header">
                    <Container className="px-0">
                      <Row className="align-items-center p-0 m-0">
                        <Col className="px-0">
                          <Modal.Title>Disclaimer</Modal.Title>
                        </Col>
                      </Row>
                    </Container>
                  </Modal.Header>

                  <Modal.Body className="disclaimer-body">
                    <Container className="px-0 custom-scroller modal-content-container pl-4 disclaimer-modal-container">
                      <div className="warning-content">{disclaimerText}</div>
                    </Container>
                  </Modal.Body>

                  <Modal.Footer className="admin bg-white footer-class disclaimer-footer-btn">
                    <div className="model-footer-btn txt-right p-0 m-0 border-0">
                      <button
                        onClick={() => handleClose()}
                        className="close-btn"
                      >
                        Close
                      </button>
                    </div>
                  </Modal.Footer>
                </Modal>
              </div>
            )}
          </div>
        </div>
        <div
          className="provider-details-tiles-container"
          role="table"
          aria-label="Compare Price Results"
          aria-describedby="search_results_price_compare"
        >
          <div
            id="search_results_price_compare"
            className="sr-only"
            aria-hidden={true}
          >
            Compare Price for Provider Results
          </div>
          {!isLoading && (
            <>
              {noResult ? (
                <DataNotFound searchText={searchTerm} />
              ) : (
                compareData?.map((data, index) => {
                  return (
                    <FinalResultTile
                      paramsData={paramsData}
                      data={data}
                      key={index}
                    />
                  );
                })
              )}
            </>
          )}

          {isLoading && (
            <div className="mt-5">
              {[0, 1, 2].map((ele, i) => {
                return (
                  <Fragment key={i}>
                    <CompareResultsCard />
                  </Fragment>
                );
              })}
            </div>
          )}
          {noResultsFound && (
            <LongTimeError searchText={searchTerm} linkHandler={linkHandler} />
          )}
        </div>
      </Container>
    </div>
  );
};

export default ResultPage;
